import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import './index.css'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Jason Domizio\'s personal monument to mediocrity' },
        { name: 'keywords', content: 'development, code on the beach' },
      ]}
    />
    <Header siteTitle={data.site.siteMetadata.title} file={data.file} />
    <div className="site-body">
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query siteDataQuery {
    site {
      siteMetadata {
        title
      }
    }
    file(relativePath: { eq: "bg.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 1920) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js